export enum NonProtectedTradeDeclaration {

    No = 0,
    ShouldAcceptForAppropriate = 1,
    ShouldAcceptForInAppropriate = 2,
}
